import React from 'react';
import { capitalize } from '../../metadata/formatters.js';
import { MEMBER_ROLE, ROLE_ORDER, ROLE_ICONS, PLAYER_COLUMNS } from '../../metadata/fields.js';
import { useParamsState } from '../../metadata/hooks.js';

const STRINGS = {
    NAME: gettext("Name"),
    ROLE: gettext("Role"),
    NAME_NOT_FOUND: gettext("Name Not Found")
}

function ClanMemberList({ clanMembers, selectedPeriod }) {
    const [sortColumn, setSortColumn] = useParamsState('column', 'global_rating');
    const [sortAscending, setSortAscending] = useParamsState('asc', false);
    /* clan member properties
     * status: active | ??
     * role: private | recruitment_officer | executive officer | commander
     * id: number
     * stats: array of all stats by period
     */

    const currentPeriodStats = (memberStats) => {
        return memberStats.filter((stats) => stats['period'] === selectedPeriod);
    }

    const getStat = (memberStats, fieldName) => {
        if(memberStats === undefined) {
            return false;
        }
        const currentStats = currentPeriodStats(memberStats);
        return currentStats.length > 0 ? currentPeriodStats(memberStats)[0][fieldName] : false;
    }

    const memberSort = (a, b) => {
        if(sortColumn === 'role') {
            if(sortAscending) {
                return ROLE_ORDER[a.role] - ROLE_ORDER[b.role];
            } else {
                return ROLE_ORDER[b.role] - ROLE_ORDER[a.role];
            }
        }
        let aLastPlayed = getStat(a.stats, 'last_played');
        let bLastPlayed = getStat(b.stats, 'last_played');
        let aColumn = getStat(a.stats, sortColumn);
        let bColumn = getStat(b.stats, sortColumn);

        if (aLastPlayed && !bLastPlayed) {
            return -1;
        } else if (!aLastPlayed && bLastPlayed) {
            return 1;
        } else if (aColumn && !bColumn) {
            return -1;
        } else if (!aColumn && bColumn) {
            return 1;
        } else if (aColumn && bColumn) {
            if(PLAYER_COLUMNS[sortColumn].sortHelper) {
                aColumn = PLAYER_COLUMNS[sortColumn].sortHelper(aColumn);
                bColumn = PLAYER_COLUMNS[sortColumn].sortHelper(bColumn);
            }
            if(sortAscending) {
                return aColumn - bColumn;
            } else {
                return bColumn - aColumn;
            }
        } else {
            aLastPlayed = PLAYER_COLUMNS['last_played'].sortHelper(aLastPlayed);
            bLastPlayed = PLAYER_COLUMNS['last_played'].sortHelper(bLastPlayed);
            return bLastPlayed - aLastPlayed;
        }
    }

    const memberLink = (member) => <a href={`/stats/players/${member.id}`}>{member.name ? member.name : STRINGS.NAME_NOT_FOUND}</a>;
    

    const memberRow = (member, index) => (
        <tr key={index}>
            <td className="sticky"><img src={ROLE_ICONS[member.role]}/></td>
            <td className="sticky">{memberLink(member)}</td>
            <td>{MEMBER_ROLE[member.role]}</td>
            {statCells(member)}
        </tr>
    );

    const sortArrow = (column) => {
        if(column === sortColumn){
            return sortAscending ? '↑' : '↓';
        }
    }

    const staticHeaders = (
        <>
            <th> </th>
            <th>{STRINGS.NAME}</th>
            <th className={'role' === sortColumn ? 'highlight': ''} onClick={() => handleSortSelection('role')}>{STRINGS.ROLE}<span className="clanleaderboard_table_arrow">&nbsp;{sortArrow('role')}</span></th>
        </>
    )

    const handleSortSelection = (column) => {
        if(sortColumn !== column) {
            setSortColumn(column);
            setSortAscending(false);
        } else {
            setSortAscending(!sortAscending);
        }
    }

    const statHeaders = Object.keys(PLAYER_COLUMNS).map((column, index) => {
        return (
            <th key={index} className={column === sortColumn ? 'highlight': ''} onClick={() => handleSortSelection(column)}>{ PLAYER_COLUMNS[column].label }<span className="clanleaderboard_table_arrow">&nbsp;{sortArrow(column)}</span></th>
        )
    });

    const statCells = (member) => {
        if(!member.hasOwnProperty('stats')){
            return Object.keys(PLAYER_COLUMNS).map(column => <td></td>);
        }
        const memberPeriodStats = currentPeriodStats(member.stats);
        if(memberPeriodStats?.length > 0) {
            return Object.keys(PLAYER_COLUMNS).map(column => (
                <td className={column === sortColumn ? 'highlight': ''}><span>{ PLAYER_COLUMNS[column].formatter ? PLAYER_COLUMNS[column].formatter(memberPeriodStats[0][column]) : memberPeriodStats[0][column] }</span></td>
            ));
        } else {
            return Object.keys(PLAYER_COLUMNS).map(column => <td></td>);
        }
    }

    return (
        <div className="clanleaderboard_table_overflow_wrapper">
            <table className="clanleaderboard_table_members">
                <thead>
                    <tr>
                        { staticHeaders }
                        { statHeaders }
                    </tr>
                </thead>
                <tbody>
                    { clanMembers && clanMembers.sort(memberSort).map((member, index) => (
                        memberRow(member, index)
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default ClanMemberList;
